import React from 'react'
import classNames from 'classnames'

export const style = theme => ({
    withPosition: {
        position: 'absolute',
        transform: 'translate(-50%, -50%)',
        top: ({ y }) => (y && y.endsWith && y.endsWith('%') ? y : `${y}px`),
        left: ({ x }) => (x && x.endsWith && x.endsWith('%') ? x : `${x}px`),
        display: ({ z }) => (z < 1 ? 'block' : 'none'),
        zIndex: ({ zIndex }) => (zIndex ? zIndex : 'initial'),
    },
})

const PositionWrapper = Component => ({ classes, positionClass, ...props }) => (
    <div className={classNames(classes.withPosition, positionClass)}>
        <Component {...props} />
    </div>
)

export default PositionWrapper
